export default {
  data() {
    return {
      shareInfoType: this.$route.params.type,
      agentName: this.$route.params.agent,
      // shareInfoUser: this.$route.params.user,
      shareInfoSuffix: this.$route.params.suffix,
    }
  },
  methods: {
    getLinkInfo() {
      this.$axios({
          url: '/api/v1/client/estate/link/accessLink',
          method: 'post',
          data: {
            agentName: this.agentName,
            type: this.type,
            suffix: this.shareInfoSuffix,
          }
        }).then(res => {
          this.handleDetailRes(res)
          // this.needPasswd = res.needPasswd
        })
        .catch(err => {
          this.loading = false
          this.closeFullLoading()
          this.$router.push('/404')
        })
    }
  }
}
